// extracted by mini-css-extract-plugin
export default {"leg":"OverNight_leg__qi39r","firstLeg":"OverNight_firstLeg__jdrQv","secondLeg":"OverNight_secondLeg__K45Vw","overlay":"OverNight_overlay__HR2L0","icon":"OverNight_icon__fSri1"};